import { NetworkAll, SymbolAll } from "@src/shared/api/generated"

export const getIcon = (value: string) => {
  const icon = value.split(" ")

  const [symbol, network] = icon as [SymbolAll, NetworkAll]

  return {
    network,
    symbol,
  }
}
